import { render, staticRenderFns } from "./register_client.vue?vue&type=template&id=359d2c57&"
import script from "./register_client.vue?vue&type=script&lang=js&"
export * from "./register_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports